module.exports = __webpack_public_path__ + "img/icon_success_normal@2x.16d15947.png";